import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Abonnés',
  steps: {
    upload: 'Télécharger',
    validate: 'Confirmer',
    finish: 'Terminé',
  },
  labels: {
    import: 'Importer',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
